import FeaturesServiceJal from '../_raw/features/icon_features_service_jal.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FeaturesServiceJal, { shouldSetDefaultSize: false });
